import React from 'react'

import { BarChartWidget } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'
import { padTimeSeries } from 'modules/ticketing/lib/padTimeSeries'

type OverduePoint = {
  label: string
  overdueCount: number
}

type Props = {
  data: OverduePoint[]
  period: string
}

export const InsightsOverdueChart: React.FC<Props> = ({ data, period }) => {
  const paddedData = padTimeSeries(data, period, { overdueCount: 0 })

  const chartData = paddedData.map((point) => ({
    label: point.label,
    values: {
      overdue: point.overdueCount,
    },
  }))

  return (
    <BarChartWidget
      header={{
        title: i18n.t('ticketing.inbox.insights.charts.overdue_tickets'),
      }}
      chart={{
        data: chartData,
        dataConfig: {
          overdue: {
            label: i18n.t('ticketing.inbox.insights.charts.overdue'),
            color: 'categorical-4',
          },
        },
      }}
    />
  )
}
